import {
  CreateAccessPassParam,
  FilterAccessPassesParam,
  ValidateAccessPassInBuildingParam,
} from '@resident-select/domain/access-pass';
import { createEntityCommand } from '../../../shared/base';
import { createAction, props } from '@ngrx/store';
import { SciGuaduaTransaction } from '@scifamek/guadua';

export const CreateAccessPassCommand =
  createEntityCommand<CreateAccessPassParam>('CreateAccessPassCommand');

export const FilterAccessPassesCommand = createAction(
  'FilterAccessPassesCommand',
  props<SciGuaduaTransaction<FilterAccessPassesParam>>(),
);

export const ValidateAccessPassInBuildingCommand = createAction(
  'ValidateAccessPassInBuildingCommand',
  props<SciGuaduaTransaction<ValidateAccessPassInBuildingParam>>(),
);
